import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, onUnmounted, ref } from "vue";
import { MotionProperties, useMotion } from "@vueuse/motion";

interface ParallaxWrapperInterface {
  active?: boolean;
  threshold?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ParallaxWrapper',
  props: {
    active: { type: Boolean, default: true },
    threshold: { default: -15 }
  },
  setup(__props: any) {

const props = __props as { active: boolean, threshold: number };

const parallaxWrapperClassName = "parallax-wrapper";



const motionMatchMedia = window.matchMedia("(prefers-reduced-motion)");
const wrapperRef = ref<HTMLElement>();

const interpolateTransform = (
  w: number,
  x: number,
  y: number
): MotionProperties => ({
  perspective: `${w}px`,
  rotateX: `${x}deg`,
  rotateY: `${y}deg`,
});

const { apply } = useMotion(wrapperRef);

const checkMouseOver = (
  x: number,
  y: number,
  width: number,
  height: number,
  clientX: number,
  clientY: number
) => clientX > x && clientX < x + width && clientY > y && clientY < y + height;

const setDefaults = async (width: number) =>
  await apply(interpolateTransform(width, 0, 0));

const handleMouseMove = async (e: MouseEvent) => {
  if (!motionMatchMedia || !props.active || !wrapperRef.value) {
    return;
  }

  const { clientX, clientY } = e;
  const { x, y, width, height } = wrapperRef.value.getBoundingClientRect();

  const horizontal = (clientX - x) / width;
  const vertical = (clientY - y) / height;

  const rotateX = props.threshold / 2 - horizontal * props.threshold;
  const rotateY = vertical * props.threshold - props.threshold / 2;

  const isMouseOver = checkMouseOver(x, y, width, height, clientX, clientY);

  if (isMouseOver) {
    await apply(interpolateTransform(width, rotateY, rotateX));
  } else {
    await setDefaults(width);
  }
};

onMounted(() => {
  if (!wrapperRef.value) {
    return;
  }

  const { width } = wrapperRef.value.getBoundingClientRect();

  setDefaults(width);

  window.addEventListener("mousemove", handleMouseMove);
});

onUnmounted(() => {
  window.removeEventListener("mousemove", handleMouseMove);
});

const classes = computed(() => [parallaxWrapperClassName]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes))
  }, [
    _createElementVNode("div", {
      ref_key: "wrapperRef",
      ref: wrapperRef,
      class: _normalizeClass(`${parallaxWrapperClassName}__container`)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2))
}
}

})